import { PRICING_PLANS_URL } from '../config/urls';
import { FETCH_PRICING_PLANS } from './types';

export const fetchPricingPlans = () => ( dispatch, _, api ) => dispatch( {
	type: FETCH_PRICING_PLANS,
	promise: api
		.get( PRICING_PLANS_URL )
		.then( response => response.response )
} );
